import {createSlice} from '@reduxjs/toolkit'


type StateType = {
    isOpenDelete : boolean
    languageId:null | string
    language : null | any
    languages:any[],
    openLanguages : any[] | null
}

const initialState : StateType = {
    isOpenDelete:false,
    languageId:null,
    language:null,
    openLanguages:null,
    languages:[]
}


const languageSlice = createSlice({
    name:"language",
    initialState,
    reducers:{
        setLanguages : (state,action) => {
            state.languages = action.payload
        },
        setOpenLanguages : (state,action) => {
            state.openLanguages = action.payload
        },
        setLanguage : (state,action) => {
            state.language = action.payload
        },
        openDeleteModal : (state,action) => {
            state.isOpenDelete = true
            state.languageId = action.payload
        },
        closeDeleteModal : (state) => {
            state.isOpenDelete = false
            state.languageId = null
        },
    }

})

export const {openDeleteModal,closeDeleteModal,setLanguages,setLanguage, setOpenLanguages} = languageSlice.actions

export default languageSlice.reducer

